const app = {
  namespaced: true,
  state: {
    sideNavIndex: 0,
    orderPushState: false,
    btnLoading: false,
    dashboardShowModeAlert: JSON.parse(localStorage.getItem("se_dashboard_show_mode_alert") || "true"),
    appVersion: localStorage.getItem("se_app_version") || "",
    protocolVersion: localStorage.getItem("se_protocol_version") || "",
    pbpx: 0, //main区块 padding bottom 的值
    isTmall: localStorage.getItem("se_isTmall") || "",
    appType: localStorage.getItem("se_appType") || "",
    agreementProtocolFlag: Number(localStorage.getItem("se_agreement_protocol") || "0") || 0,
    storeLabelIconList: JSON.parse(localStorage.getItem("se_storeLabelIconList") || "[]"),
    appTypeLabelIcon: localStorage.getItem("se_appTypeLabelIcon") || "",
    autoPopOpTemplate: JSON.parse(localStorage.getItem("se_autoPopOpTemplate") || "true")
  },
  getters: {
    isAgreementProtocol(state) {
      return !!state.agreementProtocolFlag;
    }
  },
  mutations: {
    btnStartLoading(state) {
      state.btnLoading = true;
    },
    btnStopLoading(state) {
      state.btnLoading = false;
    },
    setSideNavIndex(state, data) {
      state.sideNavIndex = data;
    },
    setOrderPushState(state, data) {
      state.orderPushState = data;
    },
    setHomeData(state, data) {
      state.homeData = data;
    },
    setStoreLabelIconList(state, data) {
      state.storeLabelIconList = data;
      localStorage.setItem("se_storeLabelIconList", JSON.stringify(data));
    },
    setAppTypeLabelIcon(state, data) {
      state.appTypeLabelIcon = data;
      localStorage.setItem("se_appTypeLabelIcon", data);
    },
    setPBPX(state, data) {
      state.pbpx = data;
    },
    setAppVersionInfo(state, data) {
      state.isTmall = data.tmall || "";
      state.appType = data.appType || "";
      localStorage.setItem("se_isTmall", data.tmall || "");
      localStorage.setItem("se_appType", data.appType || "");
    },
    setAppVersion(state, data) {
      if (!data) {
        localStorage.setItem("se_app_version", "");
        state.appVersion = "";
      } else {
        localStorage.setItem("se_app_version", data);
        state.appVersion = data;
      }
    },
    setProtocolVersion(state, data) {
      if (!data) {
        localStorage.setItem("se_protocol_version", "");
        state.protocolVersion = "";
      } else {
        localStorage.setItem("se_protocol_version", data);
        state.protocolVersion = data;
      }
    },
    setAgreementProtocolFlag(state, data) {
      if (data) {
        data = 1;
      } else {
        data = 0;
      }
      state.agreementProtocolFlag = data;
      localStorage.setItem("se_agreement_protocol", data);
    },
    setAutoPopOpTemplate(state, data) {
      state.autoPopOpTemplate = data;
      localStorage.setItem("se_autoPopOpTemplate", data);
    },
    setDashboardShowModeAlert(state, data) {
      state.dashboardShowModeAlert = data;
      localStorage.setItem("se_dashboard_show_mode_alert", data);
    }
  },
  actions: {}
};

export default app;
